import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-faq-footer',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './faq-footer.component.html',
  styleUrl: './faq-footer.component.scss'
})
export class FaqFooterComponent {

}
